import { Box } from '@mui/material';
import { findMenuItemByTo, useBreadcrumbSegments } from 'remote/global';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import ComposedDrawerMenuAppBar from 'components/ComposedDrawerMenuAppBar';
import useMenuItems from 'utils/hooks/useMenuItems';
import { ROUTES } from 'utils/data/routes';

function MessagesView() {
  const tInstance = useTranslation();
  const { t } = tInstance;
  const menuItems = useMenuItems();
  const segments = useBreadcrumbSegments({ menuItems });
  const lastSegment = segments[segments.length - 1];
  const currentMenuItem = findMenuItemByTo(menuItems, lastSegment.path);

  const title: Record<string, string> = {
    [ROUTES.MessagesRoutes.HISTORY]: t('MessagesView.history.title').toString(),
    [ROUTES.MessagesRoutes.GROUP]: t('MessagesView.group.title').toString(),
  };

  const currentTitle = currentMenuItem ? title[currentMenuItem.itemKey] : lastSegment.name;

  return (
    <>
      <ComposedDrawerMenuAppBar title={currentTitle} />

      <Box sx={{ p: { xs: 1, md: 2 } }}>
        <Outlet />
      </Box>
    </>
  );
}

export default MessagesView;
